import { Badge } from "@/components/ui/Badge";
import { STATUS_BADGE_VARIANTS } from "@/pages/InvoicesPage.styles";
import type { StatusBadgeProps } from "@/types/ui";
import { useTranslation } from "react-i18next";

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const { t } = useTranslation(["common", "invoices", "status"]);
  const variant = STATUS_BADGE_VARIANTS[status];
  return <Badge variant={variant}>{t(status, { ns: "status" })}</Badge>;
};

export { StatusBadge };
